module.exports = "<div> <div class=row> <div class=\"col-lg-8 col-lg-offset-2\"> <div class=page-header> <h1>Story listing</h1> </div> <div class=item-sorter> Order by: <a href=# @click.prevent=sortByAuthor>Author</a> <a href=# @click.prevent=sortByName>Story title</a> <a href=# @click.prevent=sortByWord>Words count</a> <a href=# @click.prevent=sortByPub>Published date</a> <a href=# @click.prevent=sortByUp>Updated date</a> </div> <div v-for=\"story in story_list\"> <story-info :story=story></story-info> </div> </div> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StoryList.vue
 ** module id = 78
 ** module chunks = 0
 **/